// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/social/v2/types.proto (package creativefabrica.social.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/social/v2/types.proto.
 */
export const file_creativefabrica_social_v2_types: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message creativefabrica.social.v2.Project
 */
export type Project = Message<"creativefabrica.social.v2.Project"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: repeated string product_ids = 3;
   */
  productIds: string[];

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: repeated creativefabrica.social.v2.UploadInfo uploads = 5;
   */
  uploads: UploadInfo[];

  /**
   * @generated from field: creativefabrica.social.v2.SkillLevel level = 6;
   */
  level: SkillLevel;

  /**
   * @generated from field: repeated int32 machine_ids = 7;
   */
  machineIds: number[];

  /**
   * @generated from field: repeated int32 material_ids = 8;
   */
  materialIds: number[];

  /**
   * @generated from field: repeated int32 theme_ids = 9;
   */
  themeIds: number[];

  /**
   * @generated from field: repeated creativefabrica.social.v2.Instruction instruction_items = 10;
   */
  instructionItems: Instruction[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: creativefabrica.social.v2.PostType post_type = 13;
   */
  postType: PostType;

  /**
   * @generated from field: repeated creativefabrica.social.v2.Product products = 14;
   */
  products: Product[];

  /**
   * @generated from field: int32 likes_total = 15;
   */
  likesTotal: number;

  /**
   * @generated from field: int32 comments_total = 16;
   */
  commentsTotal: number;

  /**
   * @generated from field: bool is_liked = 17;
   */
  isLiked: boolean;

  /**
   * @generated from field: bool is_saved = 18;
   */
  isSaved: boolean;

  /**
   * @generated from field: string post_slug = 19;
   */
  postSlug: string;

  /**
   * @generated from field: creativefabrica.social.v2.SocialUser author = 20;
   */
  author?: SocialUser | undefined;
};

/**
 * @generated from message creativefabrica.social.v2.Project
 */
export type ProjectJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: repeated string product_ids = 3;
   */
  productIds?: string[];

  /**
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * @generated from field: repeated creativefabrica.social.v2.UploadInfo uploads = 5;
   */
  uploads?: UploadInfoJson[];

  /**
   * @generated from field: creativefabrica.social.v2.SkillLevel level = 6;
   */
  level?: SkillLevelJson;

  /**
   * @generated from field: repeated int32 machine_ids = 7;
   */
  machineIds?: number[];

  /**
   * @generated from field: repeated int32 material_ids = 8;
   */
  materialIds?: number[];

  /**
   * @generated from field: repeated int32 theme_ids = 9;
   */
  themeIds?: number[];

  /**
   * @generated from field: repeated creativefabrica.social.v2.Instruction instruction_items = 10;
   */
  instructionItems?: InstructionJson[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: creativefabrica.social.v2.PostType post_type = 13;
   */
  postType?: PostTypeJson;

  /**
   * @generated from field: repeated creativefabrica.social.v2.Product products = 14;
   */
  products?: ProductJson[];

  /**
   * @generated from field: int32 likes_total = 15;
   */
  likesTotal?: number;

  /**
   * @generated from field: int32 comments_total = 16;
   */
  commentsTotal?: number;

  /**
   * @generated from field: bool is_liked = 17;
   */
  isLiked?: boolean;

  /**
   * @generated from field: bool is_saved = 18;
   */
  isSaved?: boolean;

  /**
   * @generated from field: string post_slug = 19;
   */
  postSlug?: string;

  /**
   * @generated from field: creativefabrica.social.v2.SocialUser author = 20;
   */
  author?: SocialUserJson;
};

/**
 * Describes the message creativefabrica.social.v2.Project.
 * Use `create(ProjectSchema)` to create a new message.
 */
export const ProjectSchema: GenMessage<Project, {jsonType: ProjectJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_types, 0);

/**
 * @generated from message creativefabrica.social.v2.UploadInfo
 */
export type UploadInfo = Message<"creativefabrica.social.v2.UploadInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: creativefabrica.social.v2.UploadInfoStatus status = 2;
   */
  status: UploadInfoStatus;

  /**
   * @generated from oneof creativefabrica.social.v2.UploadInfo.upload
   */
  upload: {
    /**
     * @generated from field: creativefabrica.social.v2.UploadInfo.VideoUpload video = 3;
     */
    value: UploadInfo_VideoUpload;
    case: "video";
  } | {
    /**
     * @generated from field: creativefabrica.social.v2.UploadInfo.ImageUpload image = 4;
     */
    value: UploadInfo_ImageUpload;
    case: "image";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.social.v2.UploadInfo
 */
export type UploadInfoJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: creativefabrica.social.v2.UploadInfoStatus status = 2;
   */
  status?: UploadInfoStatusJson;

  /**
   * @generated from field: creativefabrica.social.v2.UploadInfo.VideoUpload video = 3;
   */
  video?: UploadInfo_VideoUploadJson;

  /**
   * @generated from field: creativefabrica.social.v2.UploadInfo.ImageUpload image = 4;
   */
  image?: UploadInfo_ImageUploadJson;
};

/**
 * Describes the message creativefabrica.social.v2.UploadInfo.
 * Use `create(UploadInfoSchema)` to create a new message.
 */
export const UploadInfoSchema: GenMessage<UploadInfo, {jsonType: UploadInfoJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_types, 1);

/**
 * @generated from message creativefabrica.social.v2.UploadInfo.VideoUpload
 */
export type UploadInfo_VideoUpload = Message<"creativefabrica.social.v2.UploadInfo.VideoUpload"> & {
  /**
   * @generated from field: repeated string hls_urls = 1;
   */
  hlsUrls: string[];

  /**
   * @generated from field: repeated string mp4_urls = 2;
   */
  mp4Urls: string[];

  /**
   * @generated from field: repeated string dash_urls = 3;
   */
  dashUrls: string[];

  /**
   * @generated from field: repeated string thumbnail_urls = 4;
   */
  thumbnailUrls: string[];
};

/**
 * @generated from message creativefabrica.social.v2.UploadInfo.VideoUpload
 */
export type UploadInfo_VideoUploadJson = {
  /**
   * @generated from field: repeated string hls_urls = 1;
   */
  hlsUrls?: string[];

  /**
   * @generated from field: repeated string mp4_urls = 2;
   */
  mp4Urls?: string[];

  /**
   * @generated from field: repeated string dash_urls = 3;
   */
  dashUrls?: string[];

  /**
   * @generated from field: repeated string thumbnail_urls = 4;
   */
  thumbnailUrls?: string[];
};

/**
 * Describes the message creativefabrica.social.v2.UploadInfo.VideoUpload.
 * Use `create(UploadInfo_VideoUploadSchema)` to create a new message.
 */
export const UploadInfo_VideoUploadSchema: GenMessage<UploadInfo_VideoUpload, {jsonType: UploadInfo_VideoUploadJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_types, 1, 0);

/**
 * @generated from message creativefabrica.social.v2.UploadInfo.ImageUpload
 */
export type UploadInfo_ImageUpload = Message<"creativefabrica.social.v2.UploadInfo.ImageUpload"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string thumbnail_url = 2 [deprecated = true];
   * @deprecated
   */
  thumbnailUrl: string;

  /**
   * @generated from field: string preview_url = 3;
   */
  previewUrl: string;

  /**
   * @generated from field: repeated creativefabrica.social.v2.ThumbnailInfo thumbnails = 4;
   */
  thumbnails: ThumbnailInfo[];
};

/**
 * @generated from message creativefabrica.social.v2.UploadInfo.ImageUpload
 */
export type UploadInfo_ImageUploadJson = {
  /**
   * @generated from field: string url = 1;
   */
  url?: string;

  /**
   * @generated from field: string thumbnail_url = 2 [deprecated = true];
   * @deprecated
   */
  thumbnailUrl?: string;

  /**
   * @generated from field: string preview_url = 3;
   */
  previewUrl?: string;

  /**
   * @generated from field: repeated creativefabrica.social.v2.ThumbnailInfo thumbnails = 4;
   */
  thumbnails?: ThumbnailInfoJson[];
};

/**
 * Describes the message creativefabrica.social.v2.UploadInfo.ImageUpload.
 * Use `create(UploadInfo_ImageUploadSchema)` to create a new message.
 */
export const UploadInfo_ImageUploadSchema: GenMessage<UploadInfo_ImageUpload, {jsonType: UploadInfo_ImageUploadJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_types, 1, 1);

/**
 * @generated from message creativefabrica.social.v2.ThumbnailInfo
 */
export type ThumbnailInfo = Message<"creativefabrica.social.v2.ThumbnailInfo"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: int32 width = 2;
   */
  width: number;
};

/**
 * @generated from message creativefabrica.social.v2.ThumbnailInfo
 */
export type ThumbnailInfoJson = {
  /**
   * @generated from field: string url = 1;
   */
  url?: string;

  /**
   * @generated from field: int32 width = 2;
   */
  width?: number;
};

/**
 * Describes the message creativefabrica.social.v2.ThumbnailInfo.
 * Use `create(ThumbnailInfoSchema)` to create a new message.
 */
export const ThumbnailInfoSchema: GenMessage<ThumbnailInfo, {jsonType: ThumbnailInfoJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_types, 2);

/**
 * @generated from message creativefabrica.social.v2.Instruction
 */
export type Instruction = Message<"creativefabrica.social.v2.Instruction"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: repeated creativefabrica.social.v2.UploadInfo uploads = 3;
   */
  uploads: UploadInfo[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message creativefabrica.social.v2.Instruction
 */
export type InstructionJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: repeated creativefabrica.social.v2.UploadInfo uploads = 3;
   */
  uploads?: UploadInfoJson[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message creativefabrica.social.v2.Instruction.
 * Use `create(InstructionSchema)` to create a new message.
 */
export const InstructionSchema: GenMessage<Instruction, {jsonType: InstructionJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_types, 3);

/**
 * @generated from message creativefabrica.social.v2.ImageLibraryItem
 */
export type ImageLibraryItem = Message<"creativefabrica.social.v2.ImageLibraryItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string image_url = 2;
   */
  imageUrl: string;

  /**
   * @generated from field: string optimized_image_url = 3;
   */
  optimizedImageUrl: string;

  /**
   * @generated from field: string post_url = 4;
   */
  postUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 5;
   */
  createTime?: Timestamp | undefined;

  /**
   * @generated from field: int32 position = 6;
   */
  position: number;
};

/**
 * @generated from message creativefabrica.social.v2.ImageLibraryItem
 */
export type ImageLibraryItemJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string image_url = 2;
   */
  imageUrl?: string;

  /**
   * @generated from field: string optimized_image_url = 3;
   */
  optimizedImageUrl?: string;

  /**
   * @generated from field: string post_url = 4;
   */
  postUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 5;
   */
  createTime?: TimestampJson;

  /**
   * @generated from field: int32 position = 6;
   */
  position?: number;
};

/**
 * Describes the message creativefabrica.social.v2.ImageLibraryItem.
 * Use `create(ImageLibraryItemSchema)` to create a new message.
 */
export const ImageLibraryItemSchema: GenMessage<ImageLibraryItem, {jsonType: ImageLibraryItemJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_types, 4);

/**
 * @generated from message creativefabrica.social.v2.Product
 */
export type Product = Message<"creativefabrica.social.v2.Product"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string thumbnail_url = 3;
   */
  thumbnailUrl: string;

  /**
   * @generated from field: creativefabrica.social.v2.SocialUser author = 4;
   */
  author?: SocialUser | undefined;

  /**
   * @generated from field: string slug = 5;
   */
  slug: string;

  /**
   * @generated from field: string category = 6;
   */
  category: string;

  /**
   * @generated from field: string category_slug = 7;
   */
  categorySlug: string;
};

/**
 * @generated from message creativefabrica.social.v2.Product
 */
export type ProductJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string title = 2;
   */
  title?: string;

  /**
   * @generated from field: string thumbnail_url = 3;
   */
  thumbnailUrl?: string;

  /**
   * @generated from field: creativefabrica.social.v2.SocialUser author = 4;
   */
  author?: SocialUserJson;

  /**
   * @generated from field: string slug = 5;
   */
  slug?: string;

  /**
   * @generated from field: string category = 6;
   */
  category?: string;

  /**
   * @generated from field: string category_slug = 7;
   */
  categorySlug?: string;
};

/**
 * Describes the message creativefabrica.social.v2.Product.
 * Use `create(ProductSchema)` to create a new message.
 */
export const ProductSchema: GenMessage<Product, {jsonType: ProductJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_types, 5);

/**
 * @generated from message creativefabrica.social.v2.SocialUser
 */
export type SocialUser = Message<"creativefabrica.social.v2.SocialUser"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;

  /**
   * @generated from field: string slug = 4;
   */
  slug: string;
};

/**
 * @generated from message creativefabrica.social.v2.SocialUser
 */
export type SocialUserJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl?: string;

  /**
   * @generated from field: string slug = 4;
   */
  slug?: string;
};

/**
 * Describes the message creativefabrica.social.v2.SocialUser.
 * Use `create(SocialUserSchema)` to create a new message.
 */
export const SocialUserSchema: GenMessage<SocialUser, {jsonType: SocialUserJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_social_v2_types, 6);

/**
 * @generated from enum creativefabrica.social.v2.UploadInfoStatus
 */
export enum UploadInfoStatus {
  /**
   * @generated from enum value: UPLOAD_INFO_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: UPLOAD_INFO_STATUS_SUCCESS = 1;
   */
  SUCCESS = 1,

  /**
   * @generated from enum value: UPLOAD_INFO_STATUS_ERROR = 2;
   */
  ERROR = 2,

  /**
   * @generated from enum value: UPLOAD_INFO_STATUS_PROCESSING = 3;
   */
  PROCESSING = 3,
}

/**
 * @generated from enum creativefabrica.social.v2.UploadInfoStatus
 */
export type UploadInfoStatusJson = "UPLOAD_INFO_STATUS_UNSPECIFIED" | "UPLOAD_INFO_STATUS_SUCCESS" | "UPLOAD_INFO_STATUS_ERROR" | "UPLOAD_INFO_STATUS_PROCESSING";

/**
 * Describes the enum creativefabrica.social.v2.UploadInfoStatus.
 */
export const UploadInfoStatusSchema: GenEnum<UploadInfoStatus, UploadInfoStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_social_v2_types, 0);

/**
 * @generated from enum creativefabrica.social.v2.SkillLevel
 */
export enum SkillLevel {
  /**
   * @generated from enum value: SKILL_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SKILL_LEVEL_BEGINNER = 1;
   */
  BEGINNER = 1,

  /**
   * @generated from enum value: SKILL_LEVEL_INTERMEDIATE = 2;
   */
  INTERMEDIATE = 2,

  /**
   * @generated from enum value: SKILL_LEVEL_ADVANCED = 3;
   */
  ADVANCED = 3,
}

/**
 * @generated from enum creativefabrica.social.v2.SkillLevel
 */
export type SkillLevelJson = "SKILL_LEVEL_UNSPECIFIED" | "SKILL_LEVEL_BEGINNER" | "SKILL_LEVEL_INTERMEDIATE" | "SKILL_LEVEL_ADVANCED";

/**
 * Describes the enum creativefabrica.social.v2.SkillLevel.
 */
export const SkillLevelSchema: GenEnum<SkillLevel, SkillLevelJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_social_v2_types, 1);

/**
 * @generated from enum creativefabrica.social.v2.PostType
 */
export enum PostType {
  /**
   * @generated from enum value: POST_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: POST_TYPE_PRODUCT_PROJECT = 1;
   */
  PRODUCT_PROJECT = 1,

  /**
   * @generated from enum value: POST_TYPE_CLASSES_PROJECT = 2;
   */
  CLASSES_PROJECT = 2,
}

/**
 * @generated from enum creativefabrica.social.v2.PostType
 */
export type PostTypeJson = "POST_TYPE_UNSPECIFIED" | "POST_TYPE_PRODUCT_PROJECT" | "POST_TYPE_CLASSES_PROJECT";

/**
 * Describes the enum creativefabrica.social.v2.PostType.
 */
export const PostTypeSchema: GenEnum<PostType, PostTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_social_v2_types, 2);

